import { JSX } from "react";

export const Login = (): JSX.Element => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="18"
            viewBox="0 0 21 18"
            fill="none"
        >
            <path
                d="M9.5 4L8.1 5.4L10.7 8H0.5V10H10.7L8.1 12.6L9.5 14L14.5 9L9.5 4ZM18.5 16H10.5V18H18.5C19.6 18 20.5 17.1 20.5 16V2C20.5 0.9 19.6 0 18.5 0H10.5V2H18.5V16Z"
                fill="white"
            />
        </svg>
    );
};
